import React, { useState, useEffect, useRef } from 'react';

const Counter = props => {
    const { to, from, speed, onComplete, digits } = props;
    const [delay] = useState(props.delay || 100);
    const [counter, setCounter] = useState(from || 0);
    const [loops, setLoops] = useState(Math.ceil(speed / delay));
    const [loopsCounter, setLoopsCounter] = useState(0);
    const [increment, setIncrement] = useState((to - counter) / loops);
    const loopsCounterRef = useRef(0);
    const counterRef = useRef(from || 0);
    const incrementRef = useRef((to - counter) / loops);
    const [intervalState, setIntervalState] = useState(0);

    useEffect(() => {
        loopsCounterRef.current = loopsCounter;
        counterRef.current = counter;
        incrementRef.current = increment;
    });

    useEffect(() => {
        clear();
        setLoops(Math.ceil(speed / delay));
        setLoopsCounter(0);
        setIncrement((to - counter) / loops);
        setIntervalState(setInterval(next, delay));
    }, [to]);

    const next = () => {
        if (loopsCounterRef.current < loops) {
            setLoopsCounter(loopsCounterRef.current + 1);
            setCounter(counterRef.current + incrementRef.current);
        } else {
            clear();
            if (onComplete) onComplete();
        }
    };

    const clear = () => {
        setIntervalState(clearInterval(intervalState));
        return <span className={props.className}>{counter.toFixed(digits)}</span>;
    };

    return <span className={props.className}>{counter.toFixed(digits)}</span>;
};

export default Counter;
